import { render } from "./DetailComponent1Update.vue?vue&type=template&id=81313fda&scoped=true"
import script from "./DetailComponent1Update.vue?vue&type=script&lang=js"
export * from "./DetailComponent1Update.vue?vue&type=script&lang=js"

import "./DetailComponent1Update.vue?vue&type=style&index=0&id=81313fda&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81313fda"]])

export default __exports__